// Zentrale Konfiguration.
//
// Der Chat spricht Ollama ueber den eigenen nginx an (/ollama, same-origin).
// Grund: Das Frontend wird per HTTPS ausgeliefert. Ein direkter Aufruf von
// http://129.217.230.209:11434 aus dem Browser waere Mixed Content und wuerde
// blockiert - auch im VPN.
//
// Damit Ollama trotzdem nicht oeffentlich nutzbar ist, beschraenkt nginx die
// Location /ollama/ auf die Netze der TU (siehe nginx/templates/default.conf.template).
// Wer nicht im Hochschulnetz oder VPN sitzt, bekommt HTTP 403 - darauf zeigt der
// Chat den VPN-Hinweis und wird ausgegraut.
//
// REACT_APP_* wird von Create React App zur Buildzeit fest eingebacken.

const trimSlash = (value) => (value || '').replace(/\/+$/, '');

export const OLLAMA_BASE_URL = trimSlash(process.env.REACT_APP_OLLAMA_URL || '/ollama');

// Frontend und API liegen hinter demselben Reverse Proxy auf einer Origin
// (location / bzw. location /api/v1/), deshalb relativ. Das ist unabhaengig vom
// Hostnamen und erspart CORS. In der Entwicklung proxyt src/setupProxy.js.
export const TRANSCRIPTION_BASE_URL = trimSlash(
    process.env.REACT_APP_TRANSCRIPTION_URL || '/api/v1'
);

/** Host, auf dem Ollama laeuft - nur fuer die Anzeige in Statusmeldungen. */
export const OLLAMA_HOST_LABEL = process.env.REACT_APP_OLLAMA_HOST || '129.217.230.209';

// Poll-Intervalle in ms
export const OLLAMA_POLL_MS = 3000;
export const TRANSCRIPTION_POLL_MS = 5000;

// Zeitlimit fuer Statusabfragen, damit der Hinweis zuegig erscheint, wenn der
// Dienst haengt statt sauber abzulehnen.
export const OLLAMA_TIMEOUT_MS = 6000;

// Wie lange nach dem letzten beobachteten Aktivitaetssignal ein Modell noch als
// "in Benutzung" gilt. Muss groesser als OLLAMA_POLL_MS sein, damit ein einzelner
// verpasster Poll nicht sofort auf "frei" springt.
export const ACTIVITY_GRACE_MS = 9000;

export const CONTACT_EMAIL = 'patrick.stuckmann@tu-dortmund.de';
export const CONTACT_NAME = 'Patrick Stuckmann';
